export default {
  headText: "klang Netzwerke",
  headSubtext:
    "Nach einem Unfall steht die medizinische Versorgung an oberster Stelle.",
};
